<div class="modal-header">
    <div class="title">
        <h2 class="modal-title">Modifier les information de paiement de la boutique</h2>
        <h4 class="modal-title" style="text-transform: uppercase;">{{ this.userInfos.fullName }} </h4>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body d-flex flex-column ">

    <!-- Form create user mangopay -->
    <div *ngIf="this.userInfos.IDENTITY_PROOF.status !== 'SUCCESS' || this.userInfos.ADDRESS_PROOF.status !== 'SUCCESS'">
        <div class="container">
            <div class="row">
                <div class="col">
                    <label for="nom" class="form-label required">Nom</label>
                    <input type="text" class="form-control" id="nom" [(ngModel)]="this.userInfos.mangoFirstName">
                </div>
                <div class="col">
                    <label for="prenom" class="form-label required">Prénom</label>
                    <input type="text" class="form-control" id="prenom" [(ngModel)]="this.userInfos.mangoLastName">
                </div>

                <div class="w-100"></div>

                <div class="col">
                    <label for="email" class="form-label required">Email</label>
                    <input type="email" class="form-control" id="email" [(ngModel)]="this.userInfos.mangoEmail">
                </div>
                <div class="col">
                    <label for="email" class="form-label required">Date de naissance</label>
                    <div class="input-group">
                        <input class="form-control  date-{{date.status}}" placeholder="jj/mm/aaaa" name="d2" #date="ngModel" [(ngModel)]="this.userInfos.birthday" ngbDatepicker #d2="ngbDatepicker"
                            [startDate]="{year: 2000, month: 1}" [minDate]="minDate" [maxDate]="maxDate" >
                        <button id="date_picker" class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button"></button>
                    </div>
                    <!-- <pre>Model: {{ this.userInfos.Birthday | json }}</pre> -->
                </div>
            </div>

            <div class="w-100"></div>

            <div class="row">
                <div class="col">
                    <label for="org" class="form-label required">Nationalité</label>
                    <mat-form-field appearance="fill">
                        <mat-label>Choisir un pays</mat-label>
                        <mat-select [(value)]="this.userInfos.nationality">
                            <mat-option *ngFor="let country of countries | keyvalue" value="{{country.key}}">{{country.value}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col" *ngIf="this.role === 'Shop'">
                    <label for="org" class="form-label required">Pays de résidence</label>
                    <mat-form-field appearance="fill">
                        <mat-label>Choisir un pays</mat-label>
                        <mat-select [(value)]="this.userInfos.residencecountry">
                            <mat-option *ngFor="let country of countries | keyvalue" value="{{country.key}}">{{country.value}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div *ngIf="this.canCreateUser" class="col-sm-12 d-flex flex-column modify-block">
            <button class="modify mb-4" (click)="createUserMangopay()">
                Creer un compte mangopay
            </button>
        </div>

        <div *ngIf="!this.canCreateUser" class="col-sm-12 d-flex flex-column modify-block">
            <p class="warning_reset">Veuillez noter qu'une mise à jour de votre compte mangopay annulera toute demande de vérification KYC en cours ou validé.</p>
            <button class="modify mb-4" (click)="updateUserMangopay()">
                mettre à jour
            </button>
        </div>
    </div>

    <h2 class="modal-title text-center my-3" *ngIf="this.userInfos.mangoUserId">KYC test</h2>

    <div class="kyc-block" *ngIf="this.userInfos.mangoUserId">
        <!-- <div class="container"> -->

            <label class="form-label">Piéce d'identitée</label>

            <p class="kyc_create-message" *ngIf="!this.userInfos.IDENTITY_PROOF.status">
                renseigné une piece d'identité valide au format ( pdf, jpeg, jpg et png ) de maximum 10mo
            </p>

            <p class="kyc_wait-message" *ngIf="this.userInfos.IDENTITY_PROOF.status === 'PENDING'">
                Votre identité est en cours de validation, elle est effectuée en moyenne sous 24h les jours ouvrables bancaires (du lundi au vendredi)
            </p>

            <p class="kyc_error-message" *ngIf="this.userInfos.IDENTITY_PROOF.status === 'FAILED'">
                {{this.userInfos.IDENTITY_PROOF.raison}}
            </p>

            <p class="kyc_validate-message" *ngIf="this.userInfos.IDENTITY_PROOF.status === 'SUCCESS'">
                Votre identité a été validé !
            </p>

            <div class="container-file_input" *ngIf="!this.userInfos.IDENTITY_PROOF.status || this.userInfos.IDENTITY_PROOF.status === 'FAILED'">
                <div class="file_input">
                    <input #IDENTITY_PROOF type="file" ng2FileSelect [uploader]="uploader" accept=".pdf, .jpeg, .jpg, .png"
                        (change)="processFile($event, 'IDENTITY_PROOF')">
                    <label id="isNotValidFile_IDENTITY_PROOF" class="file_message-error">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        le document doit être inférieur à 10 Mo
                    </label>
                    <label id="isValidFile_IDENTITY_PROOF" class="file_message-success">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        Téléchargé
                    </label>
                    <label *ngIf="this.formatInvalid.IDENTITY_PROOF" class="format-invalid">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        Le format de votre fichier n'est pas correct
                    </label>
                </div>

                <div class="file_input_btn">
                    <button (click)="sendKYC('IDENTITY_PROOF')" [disabled]="!fileUpload.IDENTITY_PROOF">Envoyer</button>
                </div>
            </div>
        <!-- </div> -->
    </div>

    <div class="kyc-block" *ngIf="this.userInfos.mangoUserId">

        <!-- <div class="container"> -->

            <label class="form-label">Justificatif de domicile</label>

            <p class="kyc_create-message" *ngIf="!this.userInfos.ADDRESS_PROOF.status">
                renseigné un justificatif de domicile valide au format ( pdf, jpeg, jpg et png ) de maximum 10mo
            </p>
            <p class="kyc_wait-message" *ngIf="this.userInfos.ADDRESS_PROOF.status === 'PENDING'">
                Votre justificatif de domicile est en cours de validation, elle est effectuée en moyenne sous 24h les jours ouvrables bancaires (du lundi au vendredi)
            </p>
            <p class="kyc_error-message" *ngIf="this.userInfos.ADDRESS_PROOF.status === 'FAILED'">
                {{this.userInfos.ADDRESS_PROOF.raison}}
            </p>
            <p class="kyc_validate-message" *ngIf="this.userInfos.ADDRESS_PROOF.status === 'SUCCESS'">
                Votre justificatif de domicile a été validé !
            </p>

            <div class="container-file_input" *ngIf="!this.userInfos.ADDRESS_PROOF.status || this.userInfos.ADDRESS_PROOF.status === 'FAILED'">
                <div class="file_input">
                    <input #ADDRESS_PROOF type="file" ng2FileSelect [uploader]="uploader" accept=".pdf, .jpeg, .jpg, .png"
                        (change)="processFile($event, 'ADDRESS_PROOF')">
                    <label id="isNotValidFile_ADDRESS_PROOF" style="color: #D80000; display: none;">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        le document doit être inférieur à 10 Mo
                    </label>
                    <label id="isValidFile_ADDRESS_PROOF" style="color: #4DCC5E; display: none;">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        Téléchargé
                    </label>
                    <label *ngIf="this.formatInvalid.ADDRESS_PROOF" class="format-invalid">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                        Le format de votre fichier n'est pas correct
                    </label>
                </div>

                <div class="file_input_btn">
                    <button (click)="sendKYC('ADDRESS_PROOF')" [disabled]="!fileUpload.ADDRESS_PROOF">Envoyer</button>
                </div>
            </div>
        <!-- </div> -->
    </div>

    <!-- Form infos bank -->
    <div class="account_bank-block" *ngIf="this.showAccoutBankForm">
        <h2 class="modal-title text-center my-3">Compte bancaire</h2>
        <!-- Adresse -->
        <div class="row mx-1">
            <!-- Name -->
            <div class="col">
                <label for="name" class="form-label required">Nom complet</label>
                <input type="text" class="form-control" id="name" [(ngModel)]="this.userInfos.bankOwnerName" required [disabled]="this.disabledAccoutBankForm">
            </div>
            <!-- city -->
            <div class="col">
                <label for="city" class="form-label required">Ville</label>
                <input type="text" class="form-control" id="city" [(ngModel)]="this.userInfos.bankCity" required [disabled]="this.disabledAccoutBankForm">
            </div>
        </div>
        <div class="row mx-1">
            <!-- address -->
            <div class="col">
                <label for="address" class="form-label required">Adresse</label>
                <input type="text" class="form-control" id="address" [(ngModel)]="this.userInfos.bankAddress1" required [disabled]="this.disabledAccoutBankForm">
            </div>
            <!-- address 2 -->
            <div class="col">
                <label for="address2" class="form-label">Adresse complémentaire</label>
                <input type="text" class="form-control" id="address2" [(ngModel)]="this.userInfos.bankAddress2" [disabled]="this.disabledAccoutBankForm">
            </div>
        </div>
        <div class="row mx-1">
            <!-- zip code -->
            <div class="col">
                <label for="postalCode" class="form-label required">Code postale</label>
                <input type="text" class="form-control" id="postalCode" [(ngModel)]="this.userInfos.bankCodepostal" required [disabled]="this.disabledAccoutBankForm">
            </div>
            <!-- country -->
            <div class="col">
                <label for="country" class="form-label required">Pays</label>
                <mat-form-field appearance="fill">
                    <mat-label>Choisir un pays</mat-label>
                    <mat-select [(value)]="this.userInfos.bankCountry" [disabled]="this.disabledAccoutBankForm">
                        <mat-option *ngFor="let country of countries | keyvalue" value="{{country.key}}">{{country.value}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row mx-1">
            <div class="col">
                <label for="iban" class="form-label required">IBAN</label>
                <input type="text" class="form-control" id="iban" [(ngModel)]="this.userInfos.bankDetailsIBAN" required [disabled]="this.disabledAccoutBankForm">
            </div>
            <div class="col">
            </div>
        </div>
        <div *ngIf="!this.disabledAccoutBankForm" class="col-sm-12 d-flex flex-column modify-block">
            <button class="modify mb-4" (click)="createIbanBankAccount()">
                Sauvegarder les informations
            </button>
        </div>
        <div *ngIf="this.disabledAccoutBankForm" class="col-sm-12 d-flex flex-column modify-block">
            <p class="warning_reset">Supprimer ce compte bancaire pour en ajouter un nouveau</p>
            <button class="modify mb-4" (click)="deleteBankAccount()">
                Supprimer ce compte
            </button>
        </div>
    </div>
</div>